import axios from '@axios'

export default {
  namespaced: true,
  state: {
    patientProfile: '',
  },
  getters: {},
  mutations: {
    SET_PROFILE_DATA(state, val) {
      state.patientProfile = val
    },
  },
  actions: {
    fetchUsers(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/apps/user/users', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchUser(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/apps/user/users/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    addUser(ctx, userData) {
      return new Promise((resolve, reject) => {
        axios
          .post('/apps/user/users', { user: userData })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    getProfile(urlApi) {
      return new Promise((resolve, reject) => {
        axios
          .get(urlApi)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
